import React, { ComponentType, FunctionComponent } from 'react';

import { DataTableCellProps } from 'components/dataTable/dataTable.types';

import { COLUMN_IDS } from '../../keys';
import { ActionsCell } from './actionsCell';
import { CurrencyCell } from './currencyCell';
import { DateCell } from './dateCell';
import { DefaultCell } from './defaultCell';
import { StatusCell } from './statusCell';

const cellComponentMap: { [key: string]: ComponentType<DataTableCellProps> } = {
  [COLUMN_IDS.PAYOUT_ID]: DefaultCell,
  [COLUMN_IDS.AMOUNT]: CurrencyCell,
  [COLUMN_IDS.SUBMITTED_AT]: DateCell,
  [COLUMN_IDS.STATUS]: StatusCell,
  [COLUMN_IDS.ACTIONS]: ActionsCell,
  default: DefaultCell,
};

export const PayoutCell: FunctionComponent<DataTableCellProps> = (props) => {
  const { column } = props;
  const SelectedComponent = cellComponentMap[column.id] || cellComponentMap.default;

  return <SelectedComponent {...props} />;
};
